import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const downloadFreeCapacityPushSalesCoverage = () => {
  const url = occUrl("/fcc/download/salescoverage");

  return occFetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};

export const downloadFreeCapacityPushScope = () => {
  const url = occUrl("/fcc/download/fccscope");

  return occFetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
